import ReactGA from "react-ga4";
import { UaEventOptions } from "react-ga4/types/ga4";

export function trackEvent(
  action = "click",
  category: string = "none",
  label?: string
) {

  const isProduction = process.env.NEXT_PUBLIC_PRODUCTION;
  if (isProduction === "true") {
  let gaData: string | UaEventOptions = { action, category };
  if (!!label) gaData = { ...gaData, label };
  ReactGA.event(gaData);
  }
}
